import GravTitelKort from '../GravTitelKort';
import ObjektVySida from '../../../../_Common/Components/BusinessCollectionComponents/ObjektVySida/ObjektVySida';
import ObjektVyKolumner, {
  ObjektVyKolumn,
} from '../../../../_Common/Components/BusinessCollectionComponents/ObjektVyKolumner/ObjektVyKolumner';
import { ObjektVyKort } from '../../../../_Common/Components/BusinessCollectionComponents/ObjektVyKort/ObjektVyKort';
import {
  GravplatsQuery_node_TEDGAGrav_UDN,
  GravplatsQuery_node_TEDGAGrav as IGravplatsNode,
} from '../Queries/_QueryTypes/GravplatsQuery';
import clientAvenyModel from '../../../../../../Model/clientAvenyModel';
import EDTypography from '../../../../../../BaseComponents/Typography/EDTypography';
import EDListItem from '../../../../../../BaseComponents/List/Components/EDListItem';
import EDList from '../../../../../../BaseComponents/List/EDList';

const GravModel = clientAvenyModel.GA.BusinessModels.GAGrav;

interface INoteringarProps {
  sidNr: number;
  nodeData: IGravplatsNode | null | undefined;
  fullPage: boolean;
}

const Noteringar: React.FC<INoteringarProps> = ({
  sidNr,
  nodeData,
  fullPage,
}) => {
  const harTextVarde = (
    n: GravplatsQuery_node_TEDGAGrav_UDN | null | undefined
  ): n is GravplatsQuery_node_TEDGAGrav_UDN & { value: string } =>
    typeof n?.value === 'string' && n.value.trim().length > 0;

  const filtreradeNoteringar = (nodeData?.UDN ?? []).filter(harTextVarde);

  const noteringar =
    filtreradeNoteringar.length === 1 &&
    filtreradeNoteringar[0].name === 'NOTERINGAR'
      ? [{ ...filtreradeNoteringar[0], name: '' }]
      : filtreradeNoteringar;

  const harNoteringar = noteringar.length > 0;

  return (
    <ObjektVySida
      sidNr={sidNr}
      caption={'Noteringar'}
      collectionName={GravModel.CollectionName}
    >
      <ObjektVyKolumner>
        <ObjektVyKolumn fullPage={fullPage}>
          <GravTitelKort nodeData={nodeData} />

          <ObjektVyKort
            className="position-relative"
            backgroundColor={'white'}
            caption="Noteringar"
          >
            {harNoteringar ? (
              <EDList>
                {noteringar.map((notering, index) => (
                  <EDListItem
                    key={index}
                    disableGutters
                    style={{ display: 'block' }}
                  >
                    {notering.name && (
                      <EDTypography
                        color="textSecondary"
                        variant="caption"
                        fontWeight={'bold'}
                      >
                        {notering.name}
                      </EDTypography>
                    )}

                    <EDTypography sx={{ whiteSpace: 'pre-wrap' }}>
                      {notering.value}
                    </EDTypography>
                  </EDListItem>
                ))}
              </EDList>
            ) : (
              <EDTypography color="textSecondary">
                Inga noteringar registrerade
              </EDTypography>
            )}
          </ObjektVyKort>
        </ObjektVyKolumn>
      </ObjektVyKolumner>
    </ObjektVySida>
  );
};

export default Noteringar;
